import { render, staticRenderFns } from "./ConversationButton.vue?vue&type=template&id=1f492fe8&"
import script from "./ConversationButton.vue?vue&type=script&lang=js&"
export * from "./ConversationButton.vue?vue&type=script&lang=js&"
import style0 from "./ConversationButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports